import confetti from "canvas-confetti";

const COLORS = ["#C9A84C", "#F0C96A", "#FFFFFF", "#48BB78"];
const MESSAGES = [
  "Bien joué ! Une leçon de plus dans la poche 🎉",
  "Vous avancez sérieusement là ! Continuez comme ça 💪",
  "Leçon validée ! Votre cerveau vous remercie 🧠",
  "Excellent travail ! Vous êtes sur la bonne voie ⭐",
  "C'est dans la boîte ! Prochaine leçon ? 🚀",
];

export function fireLessonConfetti() {
  confetti({ particleCount: 80, spread: 70, origin: { y: 0.6 }, colors: COLORS });
  return MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
}

export function fireQuizConfetti() {
  const duration = 2500;
  const end = Date.now() + duration;
  (function frame() {
    confetti({ particleCount: 6, angle: 60, spread: 55, origin: { x: 0 }, colors: COLORS });
    confetti({ particleCount: 6, angle: 120, spread: 55, origin: { x: 1 }, colors: COLORS });
    if (Date.now() < end) requestAnimationFrame(frame);
  })();
}
